import { api, makeApiRequest } from 'api/_init'
import { unwrapEnvelope } from 'domain/shared/envelope'
import { mapSearchResponse, mapZipMatchResponse } from './mappers'

// Unified cross-platform location targeting search
// (app/api/v4/integrations/targeting/targeting.py) — one call searches
// Google and/or Meta in parallel and returns per-location platform_results,
// so a single search modal populates both platforms' results at once
// instead of the old Facebook-only POST /fb_targeting/search + zip_code_matching.
const targetingApi = {
  searchAsync: async (query, { platforms = ['fb'], locationTypes = [], countryCode = '' } = {}) => {
    const params = new URLSearchParams({ q: query, platforms: platforms.join(',') })
    if (countryCode) params.set('country_code', countryCode)
    locationTypes.forEach((type) => params.append('type', type))

    const response = await makeApiRequest(api, 'get', `/integrations/targeting/search?${params.toString()}`)
    const { data, error, status } = unwrapEnvelope(response)
    if (status === 200) {
      return { data: mapSearchResponse(data), status }
    }
    return { error, status }
  },

  matchPostalCodesAsync: async (countryKey, postalCodes, platforms = ['fb']) => {
    const response = await makeApiRequest(api, 'post', '/integrations/targeting/zip_code_matching', {
      country_code: countryKey,
      zips: postalCodes.map((x) => x.trim()).join(','),
      platforms: platforms.join(','),
    })
    const { data, error, status } = unwrapEnvelope(response)
    if (status === 200) {
      return { data: mapZipMatchResponse(data), status }
    }
    return { error, status }
  },

  // Meta-only — Google has no radius-suggestion API; radius is
  // user-configured for Google (ProximityCriterion) at publish time.
  getSuggestedRadiusAsync: async (location, distanceUnit) => {
    const unitMap = {
      miles: 'mile',
      mile: 'mile',
      kilometers: 'kilometer',
      km: 'kilometer',
    }
    distanceUnit = unitMap[distanceUnit] || 'mile'
    const params = new URLSearchParams({ location, distance_unit: distanceUnit })
    return await makeApiRequest(api, 'get', `/fb_targeting/suggested_radius?${params.toString()}`)
  },
}

export default targetingApi
